<div class="flex-container">
  @if (nameControl) {
    <ng-container [formGroup]="nameControl">
      <mat-form-field>
        <mat-label>Name</mat-label>
        <input autocomplete="off" id="name" matInput type="text" formControlName="name" required />
        @if (nameControl.get('name')?.hasError('required')) {
          <mat-error> Name is required. </mat-error>
        }
        @if (nameControl.get('name')?.hasError('maxlength')) {
          <mat-error> Name limited to 50 characters. </mat-error>
        }
        @if (nameControl.get('name')?.hasError('pattern')) {
          <mat-error> Name must contain characters. </mat-error>
        }
      </mat-form-field>
    </ng-container>
  }

  @if (colorControl) {
    <div class="color-picker-wrapper">
      <label>Color</label>
      <button
        mat-button
        type="button"
        matTooltip="Tile Color"
        class="color-select-button"
        #backgroundColorBtn
        (click)="onBackgroundColorPickerOpen()"
        [cpPresetColors]="['#ff1a00', '#ff8d00', '#e3ff00', '#00ff04', '#0051ff']"
        [cpAlphaChannel]="'disabled'"
        [colorPicker]="colorControl?.value?.color"
        (colorPickerChange)="onColorChange($event)"
        >
        <mat-icon>format_color_fill</mat-icon>
        <span class="font-color-swatch" [style.background-color]="colorControl?.value?.color"></span>
      </button>
    </div>
  }
</div>

@if (refreshTimeSecondsControl) {
  <ng-container [formGroup]="refreshTimeSecondsControl">
    @if (tileLayoutConfiguration.canEditRefreshTime) {
      <mat-form-field>
        <mat-label>Refresh Time (seconds)</mat-label>
        <input
          autocomplete="off"
          id="refresh-time"
          matInput
          type="text"
          inputmode="numeric"
          pattern="[0-9]*"
          formControlName="refreshTimeSeconds"
          [min]="1"
          />
          @if (refreshTimeSecondsControl.get('refreshTimeSeconds')?.hasError('pattern')) {
            <mat-error> Refresh Time must be numeric. </mat-error>
          }
          @if (refreshTimeSecondsControl.get('refreshTimeSeconds')?.hasError('min')) {
            <mat-error> Refresh Time must be at least 1 second. </mat-error>
          }
        </mat-form-field>
      }
    </ng-container>
  }

  @if ((tileSet$ | async)?.tileSetTypes?.length > 1) {
    <ndt-tile-set-type-select
      [tileId]="tileId"
      (tileSetTypeChange)="onTileSetTypeChange($event)"
    ></ndt-tile-set-type-select>
  }
